import { Injectable } from '@angular/core';
import {
  Router, Resolve,
  RouterStateSnapshot,
  ActivatedRouteSnapshot
} from '@angular/router';
import { Account } from 'app/shared/models/account';
import { catchError, EMPTY, Observable, of, tap } from 'rxjs';
import { AuthService } from '../authentication/authentication.service';
import { DataStorageService } from '../services/data-storage.service';
import { PrivateService } from '../services/private.service';

@Injectable({
  providedIn: 'root'
})
export class InitialDataResolver implements Resolve<boolean> {
  accountInfo: Account;

  constructor(
    private privateService: PrivateService,
    private dataStorage: DataStorageService,
    private router: Router,
    private authService: AuthService) { }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    const token = localStorage.getItem('jwt');
    if (token) {
      return this.privateService.getPlanInfo().pipe(
        tap((data) => {
          const planInfo = data ?? {};
          this.dataStorage.setInitialData(data);
          localStorage.setItem('planInfo', JSON.stringify(planInfo));
          return planInfo;
        }),
        catchError((error) => {
          console.error('Error fetching plan info:', error);
          this.authService.logout();
          this.router.navigate(['/login']);
          return EMPTY;
        })
      );
    } else {
      this.router.navigate(['/login']);
      return EMPTY;
    }
  }
}
